import React from 'react'
import styles from './itemCount.module.scss'

interface IItemCount {
  label?: string
  value?: number // Can be text, an image, or any ReactNode
}
const ItemCount: React.FC<IItemCount> = ({ label = 'Count', value = 0 }) => {
  return (
    <div className={styles['value_ui']}>
      <span>
        {label} : {value < 10 ? `0${value}` : value}
      </span>
    </div>
  )
}
export default ItemCount
